import { Controller } from "@hotwired/stimulus";
import bootstrap from "bootstrap/dist/js/bootstrap";

export default class extends Controller {
  static targets = ["partialToUpdate", "modal"];
  connect() {}

  updateHtml(event) {
    const [_data, _status, xhr] = event.detail;
    this.partialToUpdateTarget.innerHTML = xhr.response;
  }

  openModal(event) {
    const modal = bootstrap.Modal.getOrCreateInstance(this.modalTarget);

    if (modal) {
      modal.show();
    }
    this.updateHtml(event);
  }

  closeModal() {
    const modal = bootstrap.Modal.getInstance(this.modalTarget);
    if (modal) {
      modal.hide();
    }
  }
}
